export const activateIub = iub => {
  if (iub && iub.cs) {
    const consetPreferences = iub.cs.api?.getPreferences()?.uspr ?? {};
    // Check if consetPreferences is empty or contains at least one truthy value
    const isConsetPreferencesValid = () => {
      // Check if consetPreferences is empty
      const isEmpty = Object.keys(consetPreferences).length === 0;

      // Check if any value in consetPreferences is truthy
      const hasTruthyValue = Object.values(consetPreferences).some(value => value);

      // Return true if consetPreferences is empty or has at least one truthy value
      return isEmpty || hasTruthyValue;
    };

    // If consetPreferences is valid, start activation
    if (isConsetPreferencesValid()) {
      iub.cs.startActivation?.();
    }
  }
};

export default activateIub;
